const toMinutes = (value) => {
  if (!/^\d{2}:\d{2}$/.test(String(value || ''))) return null;
  const [hours, minutes] = String(value).split(':').map(Number);
  return hours * 60 + minutes;
};

export const buildAppointmentConflictCounts = (appointments = [], defaultDuration = 60) => {
  const groups = new Map();
  const counts = new Map();

  appointments.forEach((appointment) => {
    if (!appointment?.id || appointment.status === 'Cancelado') return;
    const start = toMinutes(appointment.start_time);
    if (start == null) return;
    const end = toMinutes(appointment.end_time) ?? start + defaultDuration;
    if (end <= start) return;

    const key = `${appointment.appointment_date || ''}:${appointment.professional_id || 'unassigned'}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({ id: appointment.id, start, end });
  });

  groups.forEach((items) => {
    items.sort((a, b) => a.start - b.start || a.end - b.end);
    for (let index = 0; index < items.length; index += 1) {
      for (let otherIndex = index + 1; otherIndex < items.length; otherIndex += 1) {
        if (items[otherIndex].start >= items[index].end) break;
        if (items[index].start < items[otherIndex].end) {
          counts.set(items[index].id, (counts.get(items[index].id) || 0) + 1);
          counts.set(items[otherIndex].id, (counts.get(items[otherIndex].id) || 0) + 1);
        }
      }
    }
  });

  return counts;
};

